// Access token lives only in memory (cleared on reload — restored via refresh).
// Refresh token persists in localStorage so a session survives page reloads.
// This is the encapsulation point: swapping to httpOnly cookies later means
// changing only this file.
let accessToken = null;
const REFRESH_KEY = 'rd_refresh_token';

export const getAccessToken = () => accessToken;
export const setAccessToken = (t) => { accessToken = t || null; };

export const getRefreshToken = () => {
  try { return localStorage.getItem(REFRESH_KEY); } catch (e) { return null; }
};
export const setRefreshToken = (t) => {
  try { if (t) localStorage.setItem(REFRESH_KEY, t); } catch (e) {}
};

export const clearTokens = () => {
  accessToken = null;
  try { localStorage.removeItem(REFRESH_KEY); } catch (e) {}
};
